import type React from 'react'
import { createContext, useContext } from 'react'
import { isNil } from 'utils'

type ActiveOperation = {
  orgCode?: string
}

const ActiveOperationContext = createContext<ActiveOperation>({
  orgCode: undefined
})

export const ActiveOrgCodeProvider: React.FC<{
  children: React.ReactNode
  orgCode: string | undefined
}> = ({ children, orgCode }) => {
  return (
    <ActiveOperationContext.Provider value={{ orgCode }}>
      {children}
    </ActiveOperationContext.Provider>
  )
}

export const useOrgCodeOrUndefined = () => {
  const { orgCode } = useContext(ActiveOperationContext)

  return orgCode
}

export const useOrgCodeOrThrow = () => {
  const { orgCode } = useContext(ActiveOperationContext)

  if (isNil(orgCode)) {
    throw new Error(
      'Expected orgCode to be defined. If this is a valid state, use useOrgCodeOrUndefined instead.'
    )
  }

  return orgCode
}
